// extracted by mini-css-extract-plugin
export default {"container":"CenterContainer_container__MP7Df"};